document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.moko-tracker-compatibility');

  sections.forEach((section) => {
    const badges = section.querySelectorAll('[data-target]');
    const videoContainers = section.querySelectorAll('[data-platform]');

    const pauseAllVideos = () => {
      videoContainers.forEach((container) => {
        const video = container.querySelector('video');
        if (video) video.pause();
        container.classList.remove('is-playing');
      });
    };

    badges.forEach((badge) => {
      badge.addEventListener('click', () => {
        const { target } = badge.dataset;

        pauseAllVideos();

        videoContainers.forEach((container) => {
          container.classList.toggle('is-hidden', container.dataset.platform !== target);
        });

        badges.forEach((b) => b.classList.remove('is-active'));
        badge.classList.add('is-active');
      });
    });

    const playButtons = section.querySelectorAll('.moko-tracker-compatibility__play-button');

    playButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const container = button.closest('[data-platform]');
        const video = container?.querySelector('video');
        if (!video) return;

        if (video.paused) {
          video.play()
            .then(() => container.classList.add('is-playing'))
            .catch(() => {});
        } else {
          video.pause();
          container.classList.remove('is-playing');
        }
      });
    });

    const expandButtons = section.querySelectorAll('.moko-tracker-compatibility__expand-button');

    expandButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const container = button.closest('[data-platform]');
        const video = container?.querySelector('video');
        if (!video) return;

        const requestFullscreen = video.requestFullscreen
          ?? video.webkitRequestFullscreen
          ?? video.msRequestFullscreen;

        if (requestFullscreen) {
          requestFullscreen.call(video).then(() => {
            video.play()
              .then(() => container.classList.add('is-playing'))
              .catch(() => {});
          }).catch(() => {});
        }
      });
    });

    const handleFullscreenExit = () => {
      const fsElement = document.fullscreenElement ?? document.webkitFullscreenElement;
      if (fsElement) return;

      videoContainers.forEach((container) => {
        const video = container.querySelector('video');
        if (!video) return;
        video.pause();
        container.classList.remove('is-playing');
      });
    };

    document.addEventListener('fullscreenchange', handleFullscreenExit);
    document.addEventListener('webkitfullscreenchange', handleFullscreenExit);

    const videoWrapper = section.querySelector('.moko-tracker-compatibility__video-wrapper');

    if (videoWrapper) {
      const viewObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) pauseAllVideos();
        });
      }, { threshold: 0 });

      viewObserver.observe(videoWrapper);
    }

    const videos = section.querySelectorAll('video');

    videos.forEach((video) => {
      const container = video.closest('[data-platform]');

      video.addEventListener('pause', () => {
        container?.classList.remove('is-playing');
      });

      video.addEventListener('ended', () => {
        container?.classList.remove('is-playing');
      });
    });
  });
});
